import ColumnTypes from '../../components/Database/types/ColumnTypes';
import DatabaseController from '../../components/Database/controllers/Database';
export default function getDefaultValue() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$currentUserId = _ref.currentUserId,
      currentUserId = _ref$currentUserId === void 0 ? 'anon' : _ref$currentUserId,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;

  var controller = new DatabaseController({
    currentUserId: currentUserId
  });
  controller.insertColumn({
    name: 'Name',
    type: ColumnTypes.TEXT
  }).insertColumn({
    name: 'Notes',
    type: ColumnTypes.NOTES
  }).insertColumn({
    name: 'Tags',
    type: ColumnTypes.MULTI_SELECT
  }).insertRecord().insertRecord().insertRecord().setAttributes({
    title: title
  });
  return controller.value;
}